import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { NODE_NAME_TO_PROCESSOR_DEFINITION_MAPS } from '../globals';
import { getNativeContext } from '../helpers/get-native-context';
import { wrapEventListener } from '../helpers/wrap-event-listener';
import { ReadOnlyMap } from '../read-only-map';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  // Bug #61: The channelCountMode should be 'max' according to the spec but is set to 'explicit' to achieve consistent behavior.
  channelCountMode: 'explicit',
  channelInterpretation: 'speakers',
  numberOfInputs: 1,
  numberOfOutputs: 1,
  outputChannelCount: undefined,
  parameterData: {},
  processorOptions: null
};

var createChannelCount = function createChannelCount(length) {
  var channelCount = [];

  for (var i = 0; i < length; i += 1) {
    channelCount.push(1);
  }

  return channelCount;
};

var sanitizedOptions = function sanitizedOptions(options) {
  return _objectSpread({}, options, {
    outputChannelCount: options.outputChannelCount !== undefined ? options.outputChannelCount : options.numberOfInputs === 1 && options.numberOfOutputs === 1 ?
    /*
     * Bug #61: This should be the computedNumberOfChannels, but unfortunately that is almost impossible to fake. That's why
     * the channelCountMode is required to be 'explicit' as long as there is not a native implementation in every browser. That
     * makes sure the computedNumberOfChannels is equivilant to the channelCount which makes it much easier to compute.
     */
    [options.channelCount] : createChannelCount(options.numberOfOutputs),
    // Bug #66: The default value of processorOptions should be null, but Chrome Canary doesn't like it.
    processorOptions: options.processorOptions === null ? {} : options.processorOptions
  });
};

export var createAudioWorkletNodeConstructor = function createAudioWorkletNodeConstructor(createAudioParam, createAudioWorkletNodeRenderer, createNativeAudioWorkletNode, gainNodeConstructor, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(AudioWorkletNode, _noneAudioDestination);

      function AudioWorkletNode(context, name) {
        var _this;

        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;

        _classCallCheck(this, AudioWorkletNode);

        var nativeContext = getNativeContext(context);
        var isOffline = isNativeOfflineAudioContext(nativeContext);
        var mergedOptions = sanitizedOptions(_objectSpread({}, DEFAULT_OPTIONS, options));
        var nodeNameToProcessorDefinitionMap = NODE_NAME_TO_PROCESSOR_DEFINITION_MAPS.get(nativeContext);
        var processorDefinition = nodeNameToProcessorDefinitionMap === undefined ? undefined : nodeNameToProcessorDefinitionMap.get(name);
        var nativeAudioWorkletNode = createNativeAudioWorkletNode(nativeContext, isOffline ? null : context.baseLatency, nativeAudioWorkletNodeConstructor, name, processorDefinition, mergedOptions);
        var audioWorkletNodeRenderer = isOffline ? createAudioWorkletNodeRenderer(name, mergedOptions, processorDefinition) : null;
        /*
         * @todo Add a mechanism to switch an AudioWorkletNode to passive once the process() function of the AudioWorkletProcessor
         * returns false.
         */

        _this = _possibleConstructorReturn(this, _getPrototypeOf(AudioWorkletNode).call(this, context, 'active', nativeAudioWorkletNode, audioWorkletNodeRenderer));
        var parameters = [];
        nativeAudioWorkletNode.parameters.forEach(function (nativeAudioParam, nm) {
          var audioParam = createAudioParam(_assertThisInitialized(_this), isOffline, nativeAudioParam);
          parameters.push([nm, audioParam]);
        });
        _this._nativeAudioWorkletNode = nativeAudioWorkletNode; // Bug #86 & #87: Every browser but Firefox needs to get an unused output which should not be exposed.

        _this._numberOfOutputs = options.numberOfOutputs === 0 ? 0 : _this._nativeAudioWorkletNode.numberOfOutputs;
        _this._onprocessorerror = null;
        _this._parameters = new ReadOnlyMap(parameters);
        /*
         * Bug #86 & #87: Every browser but Firefox needs an output to be connected.
         *
         * Bug #50: Only Chrome and Safari do yet allow to create AudioNodes on a closed AudioContext. Therefore this is currently
         * faked by using another AudioContext. And that is the reason why this will fail in case of a closed AudioContext.
         */

        if (context.state !== 'closed') {
          var gainNode = new gainNodeConstructor(context, {
            gain: 0
          });

          try {
            _this.connect(gainNode).connect(context.destination);
          } catch (err) {
            if (err.name !== 'IndexSizeError') {
              throw err; // tslint:disable-line:rxjs-throw-error
            }
          }
        }

        return _this;
      }

      _createClass(AudioWorkletNode, [{
        key: "numberOfOutputs",
        get: function get() {
          return this._numberOfOutputs;
        }
      }, {
        key: "onprocessorerror",
        get: function get() {
          return this._onprocessorerror;
        },
        set: function set(value) {
          var wrappedListener = wrapEventListener(this, value);
          this._nativeAudioWorkletNode.onprocessorerror = wrappedListener;
          var nativeOnProcessorError = this._nativeAudioWorkletNode.onprocessorerror;
          this._onprocessorerror = nativeOnProcessorError === wrappedListener ? value : nativeOnProcessorError;
        }
      }, {
        key: "parameters",
        get: function get() {
          if (this._parameters === null) {
            // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            return this._nativeAudioWorkletNode.parameters;
          }

          return this._parameters;
        }
      }, {
        key: "port",
        get: function get() {
          return this._nativeAudioWorkletNode.port;
        }
      }]);

      return AudioWorkletNode;
    }(noneAudioDestinationNodeConstructor)
  );
};